import { inject, injectable } from 'inversify';
import HttpClient from '../../../http';
import { backendUrl } from 'src/config';
import {
  SendVerificationCodeResponse,
  VerifyCodeResponse,
} from './VerificationService.types';
import {
  TwilioSendVerificationCodeParams,
  TwilioVerificationServiceInterface,
  TwilioVerifyCodeParams,
} from 'src/features/verification/data/service/TwilioVerificationService.types';
import { LoginResponse } from 'src/features/auth/data/service/authService.types';

@injectable()
class TwilioVerificationService implements TwilioVerificationServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public sendVerificationCode({
    to,
    channel,
    accessToken,
  }: TwilioSendVerificationCodeParams) {
    const payload = { to, channel };

    return this.client
      .getClient()
      .post<SendVerificationCodeResponse>(`/users-otp/send/`, payload, {
        baseURL: backendUrl,
        ...(accessToken && {
          headers: { Authorization: `Token ${accessToken}` },
        }),
      });
  }

  public verifyCode({
    to,
    verificationCode,
    accessToken,
    channel,
  }: TwilioVerifyCodeParams) {
    const payload = { to, otp: verificationCode, channel };

    return this.client
      .getClient()
      .post<VerifyCodeResponse>(`/users-otp/verify/`, payload, {
        baseURL: backendUrl,
        ...(accessToken && {
          headers: { Authorization: `Token ${accessToken}` },
        }),
      });
  }

  public verifyLoginOtp(params: {
    type: 'AUTHENTICATION';
    code: string;
    phone_number?: string;
    email?: string;
  }) {
    return this.client.getClient().post<LoginResponse>(
      '/otp/verify/',
      { ...params, channel: 'all' },
      {
        baseURL: backendUrl,
      }
    );
  }

  public sendLoginOtp(params: {
    type: 'AUTHENTICATION';
    phone_number?: string;
    email?: string;
  }) {
    return this.client.getClient().post<LoginResponse>(
      '/otp/send/',
      { ...params, channel: 'all' },
      {
        baseURL: backendUrl,
      }
    );
  }
}

export default TwilioVerificationService;
